import type { BaseFields } from "@/resources/base";
import type { CampaignCoupon, CampaignCouponWithId } from "@/resources/coupon";
import type { Filter } from "@/utils/apiFilter";
import { apiClient } from "./apiClient";

class CampaignCouponService {
  async list(
    campaignIdOrCode: string,
    filter: Filter = {},
  ): Promise<CampaignCouponWithId[]> {
    try {
      const response = await apiClient.get<CampaignCouponWithId[]>(
        `/campaigns/${campaignIdOrCode}/coupons`,
        filter,
      );
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      return [];
    } catch (error) {
      console.error("Failed to list coupons:", error);
      return [];
    }
  }

  async createMany(
    campaignIdOrCode: string,
    coupons: Omit<CampaignCoupon, keyof BaseFields>[],
  ): Promise<CampaignCouponWithId[]> {
    try {
      const response = await apiClient.post<CampaignCouponWithId[]>(
        `/campaigns/${campaignIdOrCode}/coupons`,
        {
          coupons,
        },
      );
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      return [];
    } catch (error) {
      console.error("Failed to create coupons:", error);
      return [];
    }
  }

  async updateByCampaignIdAndCouponCode(
    campaignId: string,
    couponCode: string,
    couponData: Partial<CampaignCoupon>,
  ): Promise<boolean> {
    try {
      const response = await apiClient.put(
        `/campaigns/${campaignId}/coupons/${couponCode}`,
        couponData,
      );
      return response.status === "OK";
    } catch (error) {
      console.error("Failed to update coupon:", error);
      return false;
    }
  }

  async deleteByCampaignIdAndCouponCode(
    campaignId: string,
    couponCode: string,
  ): Promise<boolean> {
    try {
      const response = await apiClient.delete(
        `/campaigns/${campaignId}/coupons/${couponCode}`,
      );
      return response.status === "OK";
    } catch (error) {
      console.error("Failed to delete coupon:", error);
      return false;
    }
  }
}

export const campaignCouponService = new CampaignCouponService();
